import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppService } from '../../app.service';


@Component({
    selector: 'app-inline-keypad',
    templateUrl: './inline-keypad.component.html',
    styleUrl: './inline-keypad.component.scss',
    standalone: false
})
export class InlineKeypadComponent implements OnInit {
	@Output() public onChange = new EventEmitter<{}>();
	@Output() public onSubmit = new EventEmitter<{}>();
	@Input() public data: any;


	keys: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, '.', 0, 'back'];
	wasFirstClick: boolean = false;

	constructor(
		public appService: AppService
	) {

	}

	ngOnInit() {
		if (!this.data.enableDecimals) {
			this.keys[9] = null;
		}
	}

	submit() {
		this.onSubmit.emit(this.data);
	}

	setAmaountKey(key) {
		let newVal = this.data.amountText || '';
		let hasDecimal = newVal.indexOf(".") != -1;
		let precision = hasDecimal && newVal.split(".")[1].length || 0;

		switch (key) {
			case 'back':
				if (!newVal.length) newVal = '';
				else newVal = newVal.slice(0, -1);
				break;
			case '.':
				if (hasDecimal) return;
				newVal += key;
				break;
			default:
				if (!this.wasFirstClick) newVal = key + "";
				else {
					if (precision == 2) return;
					newVal += key;
				}
		}
		if (this.data.maxLength && newVal.length > this.data.maxLength) {
			return;
		}

		this.wasFirstClick = true;
		this.data.amountText = newVal;
		delete this.data.invalid;

		switch (this.data.type) {
			case "code":
				this.data.amount = newVal;
				this.data.amountText = newVal;
				break;
			default:
				if (Number(newVal) > 9999999) {
					this.data.amount = this.data.maxVal;
					this.data.amountText = this.data.maxVal + "";
				} else if (Number(newVal) > this.data.maxVal) {
					this.data.amount = Number(newVal);
					this.data.invalid = true;
				} else {
					this.data.amount = Number(newVal);
				}
				break;
		}

		this.data.wasChanged = true;
		this.onChange.emit(this.data);
	}


}
